import { useNavigate } from "react-router-dom";
import {
    Grid,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Box,
    InputLabel,
    SelectChangeEvent,
    CardMedia,
    Input,
    FormControlLabel,
    RadioGroup,
} from "@mui/material";
import { useState, ChangeEvent } from "react";
import PhoneInput from "react-phone-input-2";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import "react-phone-input-2/lib/style.css";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Radio } from "@mui/material";



const BouteekBranding = () => {
    const navigate = useNavigate();

    // State for form fields (basic setup)
    const [brandName, setBrandName] = useState("");
    const [tagline, setTagline] = useState("");
    const [footerTagline, setFooterTagline] = useState("");
    const [primaryColor, setPrimaryColor] = useState("#000000");
    const [secondaryColor, setSecondaryColor] = useState("#ffffff");
    const [supportEmail, setSupportEmail] = useState("");
    const [supportPhone, setSupportPhone] = useState("");
    const [altSupportPhone, setAltSupportPhone] = useState("");
    const [whatsappContact, setWhatsappContact] = useState("");
    const [copyrightText, setCopyrightText] = useState("");
    const [facebookUrl, setFacebookUrl] = useState("");
    const [instagramUrl, setInstagramUrl] = useState("");
    const [twitterUrl, setTwitterUrl] = useState("");
    const [youtubeUrl, setYoutubeUrl] = useState("");
    const [tiktokUrl, setTiktokUrl] = useState("");
    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const [addresses, setAddresses] = useState([
        { id: 1, text: "" }
    ]);
    const [selectedAddressId, setSelectedAddressId] = useState<number>(1);

    const handleAddAddress = () => {
        const newId = addresses.length > 0 ? Math.max(...addresses.map(a => a.id)) + 1 : 1;
        setAddresses([...addresses, { id: newId, text: "" }]);
    };

    const handleAddressChange = (id: number, text: string) => {
        setAddresses(prev => prev.map(a => a.id === id ? { ...a, text } : a));
    };

    const handleRemoveAddress = (id: number) => {
        if (addresses.length > 1) {
            setAddresses(prev => prev.filter(a => a.id !== id));
            // If the selected address is removed, fallback to the first remaining one
            if (selectedAddressId === id) {
                const firstRemaining = addresses.find(a => a.id !== id);
                if (firstRemaining) setSelectedAddressId(firstRemaining.id);
            }
        }
    };

    return (
        <>
            <div className="bouteek_branding_page">
                <div className="main_title">
                    <h1>Bouteek Branding</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                        <button onClick={() => navigate("/manage-system-settings")}>Settings</button> - Bouteek Branding
                    </p>
                </div>
                <div className="cards_grid_wrapper">
                    <form className="form">
                        <Grid container spacing={3}>
                            {/* Brand Identity */}
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: "100%" }} className="branding_card">
                                    <CardContent>
                                        {/* Store Image */}
                                        <div className="control_group w_100">
                                            <label htmlFor="vendor-logo">Image</label>
                                            {image ? (
                                                <div className="upload_image inner_bouteek_page">
                                                    <div className="upload_image_holder no_radius">
                                                        <figure>
                                                            <CardMedia component="img" image={image} alt="Store Logo" />
                                                        </figure>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setImage("");
                                                                setFileName("");
                                                            }}
                                                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                                                            aria-label="Remove image"
                                                        >
                                                            <CloseIcon />
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <Input
                                                        sx={{ display: "none" }}
                                                        id="vendor-logo"
                                                        type="file"
                                                        inputProps={{ accept: "image/png,image/jpeg" }}
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                            const files = e.target.files;
                                                            if (files && files[0]) {
                                                                setFileName(files[0].name);
                                                                setImage(URL.createObjectURL(files[0]));
                                                            }
                                                        }}
                                                    />
                                                    <label className="upload_image" htmlFor="vendor-logo">
                                                        <span className="upload_image_holder no_radius">
                                                            <figure className="add_img">
                                                                <img src="/static/images/placeholder.png" alt="placeholder" />
                                                                <span className="upload_img_icon">
                                                                    <img src="/static/images/edit2_icon.svg" alt="edit" />
                                                                </span>
                                                            </figure>
                                                        </span>
                                                    </label>
                                                </>
                                            )}
                                        </div>
                                        <div className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Brand Identity
                                            </Typography>
                                        </div>
                                        <div className="gap_p">
                                            <div className="control_group w_100">
                                                <InputLabel>Brand Name</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter Brand Name"
                                                    value={brandName}
                                                    onChange={(e) => setBrandName(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Platform Tagline</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter Tagline"
                                                    value={tagline}
                                                    onChange={(e) => setTagline(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Footer Tagline</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter Tagline"
                                                    value={footerTagline}
                                                    onChange={(e) => setFooterTagline(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: "100%" }} className="branding_card">
                                    <CardContent>
                                        <div className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Color Theme
                                            </Typography>
                                        </div>
                                        <div className="gap_p">
                                            <div className="control_group w_100">
                                                <InputLabel>Primary Color</InputLabel>
                                                <Box display="flex" alignItems="center" gap={2} className="color_input_wrapper">
                                                    <div className="color_preview_box">
                                                        <input
                                                            type="color"
                                                            value={primaryColor}
                                                            onChange={(e) => setPrimaryColor(e.target.value)}
                                                        />
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        value={primaryColor}
                                                        onChange={(e) => setPrimaryColor(e.target.value)}
                                                    />
                                                </Box>
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Secondary Color</InputLabel>
                                                <Box display="flex" alignItems="center" gap={2} className="color_input_wrapper">
                                                    <div className="color_preview_box">
                                                        <input
                                                            type="color"
                                                            value={secondaryColor}
                                                            onChange={(e) => setSecondaryColor(e.target.value)}
                                                        />
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        value={secondaryColor}
                                                        onChange={(e) => setSecondaryColor(e.target.value)}
                                                    />
                                                </Box>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: "100%" }} className="branding_card">
                                    <CardContent>
                                        <div className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Contact Information
                                            </Typography>
                                        </div>
                                        <div className="gap_p">
                                            <div className="control_group w_100">
                                                <InputLabel>Support Email</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    placeholder="Enter Support Email"
                                                    value={supportEmail}
                                                    onChange={(e) => setSupportEmail(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Support Phone </InputLabel>
                                                <PhoneInput
                                                    country={"ae"}
                                                    value={supportPhone}
                                                    onChange={(phone) => setSupportPhone(phone)}
                                                    inputStyle={{ width: "100%" }}
                                                    buttonStyle={{ border: "1px solid #ced4da" }}
                                                />
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Alternate Support Phone </InputLabel>
                                                <PhoneInput
                                                    country={"ae"}
                                                    value={altSupportPhone}
                                                    onChange={(phone) => setAltSupportPhone(phone)}
                                                    inputStyle={{ width: "100%" }}
                                                    buttonStyle={{ border: "1px solid #ced4da" }}
                                                />
                                            </div>
                                            <div className="control_group w_100">
                                                <InputLabel>Whats App Contact</InputLabel>
                                                <PhoneInput
                                                    country={"ae"}
                                                    value={whatsappContact}
                                                    onChange={(phone) => setWhatsappContact(phone)}
                                                    inputStyle={{ width: "100%" }}
                                                    buttonStyle={{ border: "1px solid #ced4da" }}
                                                />
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* Social Media */}
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: "100%" }} className="branding_card">
                                    <CardContent>
                                        <div className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Social Media
                                            </Typography>
                                        </div>
                                        <div className="gap_p">
                                            <div className="control_group w_100 social_input">
                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                    <FacebookIcon color="primary" />
                                                    <InputLabel style={{ marginBottom: 0 }}>Facebook URL</InputLabel>
                                                </Box>
                                                <TextField
                                                    fullWidth
                                                    placeholder="https://facebook.com/..."
                                                    value={facebookUrl}
                                                    onChange={(e) => setFacebookUrl(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100 social_input">
                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                    <InstagramIcon sx={{ color: "#E1306C" }} />
                                                    <InputLabel style={{ marginBottom: 0 }}>Instagram URL</InputLabel>
                                                </Box>
                                                <TextField
                                                    fullWidth
                                                    placeholder="https://instagram.com/..."
                                                    value={instagramUrl}
                                                    onChange={(e) => setInstagramUrl(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100 social_input">
                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                    <TwitterIcon color="primary" />
                                                    <InputLabel style={{ marginBottom: 0 }}>Twitter URL</InputLabel>
                                                </Box>
                                                <TextField
                                                    fullWidth
                                                    placeholder="https://twitter.com/..."
                                                    value={twitterUrl}
                                                    onChange={(e) => setTwitterUrl(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100 social_input">
                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                    <YouTubeIcon color="error" />
                                                    <InputLabel style={{ marginBottom: 0 }}>Youtube URL</InputLabel>
                                                </Box>
                                                <TextField
                                                    fullWidth
                                                    placeholder="https://youtube.com/..."
                                                    value={youtubeUrl}
                                                    onChange={(e) => setYoutubeUrl(e.target.value)}
                                                />
                                            </div>
                                            <div className="control_group w_100 social_input">
                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                    <AudiotrackIcon style={{ color: "#000000" }} />
                                                    <InputLabel style={{ marginBottom: 0 }}>Tiktok URL</InputLabel>
                                                </Box>
                                                <TextField
                                                    fullWidth
                                                    placeholder="https://tiktok.com/..."
                                                    value={tiktokUrl}
                                                    onChange={(e) => setTiktokUrl(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/*addresses */}
                            <Grid item xs={12} md={6}>
                                <Card sx={{ height: "100%" }} className="branding_card">
                                    <CardContent>
                                        <Box display="flex" alignItems="center" justifyContent="space-between" className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Addresses
                                            </Typography>
                                            <Button
                                                sx={{ padding: "4px 10px" }}
                                                onClick={handleAddAddress}
                                                className="btn btn_primary sm"
                                            >
                                                Add Address
                                            </Button>
                                        </Box>

                                        <RadioGroup
                                            value={selectedAddressId}
                                            onChange={(e) => setSelectedAddressId(Number(e.target.value))}
                                        >
                                            <div className="gap_p">
                                                {addresses.map((addr, index) => (
                                                    <div key={addr.id} className="control_group w_100 social_input">
                                                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <LocationOnIcon color="error" />
                                                                <InputLabel style={{ marginBottom: 0 }}>
                                                                    Address {index + 1}
                                                                </InputLabel>
                                                            </Box>

                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                {addresses.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleRemoveAddress(addr.id)}
                                                                        style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '4px' }}
                                                                        aria-label="Remove address"
                                                                    >
                                                                        <CloseIcon fontSize="small" sx={{ color: '#999', '&:hover': { color: '#f44336' } }} />
                                                                    </button>
                                                                )}
                                                                <FormControlLabel
                                                                    value={addr.id}
                                                                    control={<Radio />}
                                                                    label=""
                                                                />
                                                            </Box>
                                                        </Box>

                                                        <TextField
                                                            fullWidth
                                                            placeholder="Enter address..."
                                                            value={addr.text}
                                                            onChange={(e) => handleAddressChange(addr.id, e.target.value)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </RadioGroup>
                                    </CardContent>
                                </Card>
                            </Grid>


                            {/* Legal */}
                            <Grid item xs={12}>
                                <Card className="branding_card">
                                    <CardContent>
                                        <div className="card_header">
                                            <Typography variant="h6" className="card_title">
                                                Legal
                                            </Typography>
                                        </div>
                                        <div className="control_group w_100">
                                            <InputLabel>Copyright Text</InputLabel>
                                            <TextField
                                                fullWidth
                                                placeholder="© 2026 Bouteek. All rights reserved."
                                                value={copyrightText}
                                                onChange={(e) => setCopyrightText(e.target.value)}
                                            />
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="flex-end" gap={2} className="action_buttons">
                                    <Button variant="outlined" color="inherit" onClick={() => navigate("/dashboard")} className="btn btn_outline">Cancel</Button>
                                    <Button variant="contained" className="btn btn_primary">Save Changes</Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </form>
                </div>
            </div>
        </>
    );
};

export default BouteekBranding;